export function getStars(averageRating: number) {
  return Array.from({ length: Math.ceil(averageRating) }).map((_, i) => {
    const star = i + 1;
    return star - 0.25 < averageRating ? 'full' : 'half';
  });
}
